import { ProgressApiClient } from "@api/progress-api/progress-api-client";
import { useCachedTokenProvider } from "@api/use-cached-token-provider";
import { BaseProjectIdProps } from "@custom-types/base-types";
import { runtimeConfig } from "@src/runtime-config";
import { useMemo } from "react";

/**
 * Initializes the progress API client and returns a memoized instance
 */
export function useProgressApiClient({
  projectId,
}: BaseProjectIdProps): ProgressApiClient {
  const tokenProvider = useCachedTokenProvider({
    projectId,
  });

  return useMemo(
    () =>
      new ProgressApiClient(
        projectId,
        tokenProvider,
        runtimeConfig.urls.progressApiUrl
      ),
    [tokenProvider, projectId]
  );
}
